(() => {
  const selector = '.product-form__submit, .cart__checkout-button, #cart-notification-button, #cart-notification-form button[name="checkout"], .cart__warnings a.button, .cart-drawer__empty-content a.button, .rich-text__buttons a.button, .banner__buttons a.button, .image-with-text__content a.button, .collection__view-all a.button, .customer button[type="submit"]';
  const decorate = () => {
    const template = document.getElementById('mhe-primary-paws');
    if (!template) return;
    document.querySelectorAll(selector).forEach(button => {
      if (!button.querySelector('.mhe-paws')) button.append(template.content.cloneNode(true));
      button.classList.add('mhe-primary-action');
    });
  };
  decorate();
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(r => r.addedNodes.length)) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; decorate(); });
  }).observe(document.body, {childList:true, subtree:true});
})();